// i18n area 'networks' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.bg-BG.meta.json.
import type { enUS } from './networks'

export const bgBG: typeof enUS = {
  networks: {
    common: {
      name: 'Име',
      scope: 'Скоуп',
      operState: 'Състояние',
      actions: 'Действия',
      create: 'Създай',
      close: 'Затвори',
      cancel: 'Отказ',
      delete: 'Изтрий',
      edit: 'Редактирай',
      save: 'Запази',
      editError: 'Неуспешна промяна',
      search: 'Търси по име',
      empty: 'Тук още няма нищо',
      saveError: 'Неуспешно запазване',
      loadError: 'Неуспешно зареждане — достъпен ли е бекендът на TVirt?',
      createError: 'Неуспешно създаване',
      deleteError: 'Неуспешно изтриване',
      deleteConfirmTitle: 'Да се изтрие ли {name}?',
      deleteConfirmBody: 'Операцията е необратима.',
      nameHint: 'Малки букви, цифри и тирета (DNS-1123)',
      up: 'Активна',
      down: 'Неактивна',
      unknown: 'Неизвестно',
      usedByVMs: 'ВМ',
      emptyTable: 'Няма записи — добавете един с бутона +'
    },
    dialogTabs: {
      general: 'Общи',
      base: 'Базова дефиниция',
      advanced: 'Разширена конфигурация',
      reserved: 'Диапазони, запазени за TVirt',
      position: 'Позиция',
      network: 'Мрежова конфигурация',
      hosts: 'Участващи възли'
    },
    reservedRanges: {
      note: 'Това са диапазоните IP адреси, запазени за TVirt, които той може да използва, за да присвоява автоматично адрес на ВМ, контейнери и т.н. ЗАБЕЛЕЖКА: IP адресите в тези диапазони не трябва да се използват извън TVirt от външни услуги/устройства.',
      from: 'От',
      to: 'До'
    },
    overlay: {
      title: 'Оверлейни мрежи',
      createTitle: 'Създай оверлейна мрежа',
      editTitle: 'Редактиране на оверлейната мрежа',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — присвоява се автоматично, ако е празно',
      subnet: 'Подмрежа',
      subnetHint: 'CIDR на оверлея — IPAM извежда автоматично записа му в регистъра',
      mtu: 'MTU',
      weight: 'Тегло',
      ceilMbps: 'Таван (Mbps)',
      fairnessHint: 'Теглото важи само при конкуренция: при свободна връзка всяка мрежа може да използва цялата честотна лента. Таванът обаче важи винаги.',
      contention: 'Конкуренция',
      contentionTip: 'Поне един възел наблюдава отпадания или overlimit С опашка по класа на тази мрежа: лентата на uplink-а е оспорвана и теглата действат. Колко и откога — в сериите net.shaping.* на възела.',
      firewallPolicy: 'Политика на защитната стена',
      hosts: 'Хостове',
      hostsTitle: 'Участващи възли',
      hostsHint: 'Всеки възел декларира своята крайна точка в ъндърлея — избор от РЕАЛНИТЕ адреси на възела, прочетени от мрежовата му конфигурация; незадължителният адрес в оверлея трябва да е в подмрежата. Участието е ограничението за разполагане.',
      hostNode: 'Възел',
      hostUnderlay: 'Ъндърлей IP',
      hostUnderlayPickNode: 'Първо изберете възела',
      hostAddress: 'Адрес в оверлея (по избор)',
      hostAddressOutside: 'Извън подмрежата на overlay ({cidr})',
      addHost: 'Добави възел',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Наблюдавана на',
      attachedNics: 'Закачени NIC'
    },
    services: {
      title: 'Мрежови услуги',
      createTitle: 'Създай мрежова услуга',
      editTitle: 'Редактиране на мрежовата услуга',
      kind: 'Тип',
      kindCategory: 'Услуги',
      selectKindHint: 'Изберете типа услуга — демонът отдолу е детайл на имплементацията, който TVirt управлява вместо вас.',
      kindLabel: {
        dhcp: 'DHCP сървър',
        ntp: 'NTP сървър',
        vpn: 'VPN сървър',
        dns: 'DNS сървър',
        gateway: 'Шлюз',
        'lb-rp': 'Балансьор на натоварване и обратно прокси',
        floatip: 'Плаващ IP'
      },
      kindDesc: {
        dhcp: 'Присвоява адреси в обслужваните подмрежи — пуловете се извеждат от подмрежата, шлюза и запазените за TVirt диапазони на мрежата.',
        dns: 'Авторитативен DNS за декларираните зони — записите се извеждат от IPAM плюс вашите ръчни.',
        gateway: 'Възелът служи за шлюз на една мрежа — NAT (DNAT, 1:1, SNAT/masquerade) плюс статично маршрутизиране между закачените мрежи, самовъзстановяващ се по дизайн.',
        'lb-rp': 'Балансьор / обратно прокси пред услугите ви — L4 или L7 слушатели върху пулове от членове или върху готовите инстанции на Pod, преконфигурирани в движение.',
        ntp: 'Часовата услуга на мрежите — реле на външни upstream сървъри или часовникът на възела, сервиран на клиентите.',
        vpn: 'VPN концентратор на възела — WireGuard или OpenVPN, вие избирате: отдалечен достъп за пътуващите клиенти или site to site тунел между две мрежи.',
        floatip: 'Един адрес, който стои само на една здрава App инстанция или Pod и се премества към следващата здрава цел, когато тя падне — failover без демони; балансирането остава на load balancer-а.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Плаващият IP живее в избраната мрежа като ДОПЪЛНИТЕЛЕН адрес в собственото пространство на държащата инстанция: без портове, без балансиране, без NAT — IP на клиента остава истински.',
        address: 'Плаващ IP',
        targets: 'Цели',
        targetsHint: 'По ред на ПРЕДПОЧИТАНИЕ: първата здрава цел държи адреса. Pod означава всичките му инстанции, по реплика; всяка цел има собствен критерий за здраве. Всяка цел трябва да е закачена към същата мрежа.',
        targetKind: 'Цел',
        targetApp: 'App инстанция',
        targetPod: 'Pod (всички инстанции)',
        targetRef: 'Коя',
        health: 'Здраве',
        healthRunning: 'Работи (всеки контейнер готов)',
        healthTcp: 'TCP връзка',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Порт',
        path: 'Път',
        addTarget: 'Добави цел',
        moveUp: 'Премести нагоре',
        moveDown: 'Премести надолу',
        preempt: 'Preempt',
        preemptHint: 'Изключено (по подразбиране): здрав държател пази адреса дори когато по-висока цел се върне — без люлеене. Включено: първата здрава цел винаги го държи.',
        holder: 'Държател',
        noHolder: 'няма здрава цел',
        since: 'от',
        verdicts: 'Наблюдавани цели',
        healthy: 'здрава',
        unhealthy: 'нездрава',
        noVerdict: 'Още не е решено — възелът авторитет записва първата присъда при следващия си проход.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Тази инстанция държи плаващия IP {address} на услугата {service}'
      },
      poolSource: 'Крайни точки',
      poolSourceMembers: 'Статични членове',
      poolSourcePod: 'Готовите инстанции на Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Порт',
      poolBackendHint: 'Крайните точки следват Pod-а: инстанция влиза, когато работи с всеки контейнер готов, и излиза веднага, когато бъде намалена или умре. Активната проверка е включена по подразбиране.',
      poolBackendCount: 'готовите инстанции на Pod {pod} на порт {port}',
      node: 'Възел',
      enabled: 'Включена',
      parked: 'Паркирана',
      subnets: 'Подмрежи',
      subnetsHint: 'IPAM подмрежите, обслужвани от тази инстанция — пуловете се извеждат от CIDR, шлюза и запазените за TVirt диапазони',
      noSubnets: 'Няма IPAM подмрежи — първо декларирайте логическа мрежа на фабриката (или оверлейна подмрежа): IPAM се извежда от тях',
      iface: 'Интерфейс на слушане',
      ifaceHint: 'Хост интерфейсът, на който услугата отваря своя сокет (напр. бридж) — задължителен: една мрежова услуга е самодостатъчна, „всички интерфейси“ вече не съществува',
      dns: 'DNS сървъри',
      domain: 'Домейн',
      detail: 'Обслужва',
      subnetCount: '{n} подмрежи',
      zones: 'Зони',
      zonesHint: 'Само авторитативен — демонът никога не прави рекурсия. A записите се извеждат от декларираните адреси на възлите в реферираните IPAM подмрежи; превключвателят Reverse обслужва и съответните in-addr.arpa зони (PTR). Една зона се обслужва от най-много една DNS инстанция във флота. Незадължителният nameserver е FQDN, записван в NS/SOA записите вместо подразбиращия се ns.<зона>; ако попада вътре в зоната, неговият A запис пак се извежда от обслужващия възел.',
      zoneName: 'Име на зоната',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM подмрежи',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ръчни записи',
      zoneRecordsHint: 'По един на ред: име ТИП стойност — типове A, CNAME, MX, TXT. При колизия на името ръчният запис печели над изведения.',
      addZone: 'Добави зона',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Инстанцията декларира ЕДНА мрежа за слушане и ЕДИН адрес — всеки слушател го връзва на своя порт; втори адрес е втора услуга.',
      listeners: 'Слушатели',
      listenersHint: 'Всеки слушател връзва адреса на инстанцията на своя порт в режим L4 (TCP passthrough — байтовете никога не се отварят) или L7 (HTTP) и препраща към някой от пуловете по-долу. Двойка адрес/порт се обслужва от най-много една инстанция на възел. Промените се прилагат в движение — без рестарт, без загубена връзка.',
      listenerName: 'Име',
      listenerMode: 'Режим',
      modeL7: 'L7 — обратно HTTP прокси',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Порт',
      listenerPool: 'Пул',
      addListener: 'Добави слушател',
      pools: 'Пулове',
      poolsHint: 'Бекендите, на които каца трафикът: статични членове, балансирани round-robin или по най-малко зает, с незадължителна активна проверка на здравето, която вади от ротацията болните членове.',
      poolName: 'Име',
      poolAlgorithm: 'Алгоритъм',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Най-малко зает',
      poolCheck: 'Проверка на здравето',
      checkNone: 'Няма',
      checkTcp: 'TCP връзка',
      checkHttp: 'HTTP',
      poolCheckPath: 'Път на сондата',
      poolInterval: 'Интервал (s)',
      poolMembers: 'Членове',
      poolMembersHint: 'По един на ред: адрес:порт, по избор последван от тегло (1-128) — напр. 10.0.0.21:8080 2',
      addPool: 'Добави пул',
      memberCount: '{n} членове',
      listen: {
        assignment: 'Присвояване',
        assignmentStatic: 'Статичен адрес',
        assignmentAuto: 'Автоматично (резервирани диапазони на TVirt)',
        autoHint: 'TVirt извлича адреса от резервираните диапазони на логическата мрежа и го държи sticky — никога не се тегли наново при редакция или failover.',
        title: 'Слушатели',
        hint: 'Една мрежова услуга е самодостатъчна: всеки слушател декларира своята мрежа (оверлей, логическа мрежа на фабриката или интерфейс) и адрес вътре в нейната подмрежа — по един слушател на адрес, уайлдкард вече не съществува. DNS и NTP могат да слушат на няколко мрежи и няколко адреса от тези мрежи.',
        address: 'Адрес на слушане',
        add: 'Добави слушател'
      },
      ntp: {
        mode: 'Режим на синхронизация',
        modeRelay: 'Реле на външни сървъри',
        modeNodeClock: 'Часовник на възела',
        modeHint: 'Релето сервира времето, взето от декларираните upstream сървъри; часовникът на възела сервира времето на обслужващия възел — което клъстерът така или иначе държи синхронизирано',
        servers: 'Upstream сървъри',
        serversHint: 'Разделени със запетая — име на хост или IP адрес; услугата взима времето оттук и го сервира на мрежата',
        port: 'Порт на слушане',
        listening: 'Слуша на'
      },

      vpn: {
        engine: 'Двигател',
        engineHint: 'Вие го избирате и той повече не се сменя: WireGuard е модерен, бърз и в ядрото; OpenVPN е ветеранът на съвместимостта (TCP, враждебни мрежи)',
        engineLocked: 'Двигателят е неизменим — друг двигател е нова услуга, ключовете и сертификатите не са преносими',
        mode: 'Режим',
        modeRemote: 'Отдалечен достъп',
        modeSite: 'Site to site',
        modeHint: 'Отдалеченият достъп дава на пътуващите клиенти адрес в тунела; site to site свързва две мрежи',
        port: 'Порт на слушане',
        protocol: 'Транспорт',
        protocolWireguardHint: 'WireGuard говори само UDP',
        tunnelSubnet: 'Подмрежа на тунела',
        tunnelSubnetHint: 'Мрежата, в която живеят клиентите — записана в IPAM регистъра, ражда се и умира с тази услуга',
        dnsServers: 'DNS, подавани на клиентите',
        routes: 'Маршрути, подавани на клиентите',
        routesHint: 'Мрежи, разделени със запетая, достижими през тунела; подмрежата на тунела винаги е включена',
        peers: 'Пиъри',
        peersHint: 'Оставете публичния ключ празен и TVirt генерира двойката — после я доставя с профила. Поставете ключ и пиърът пази своя.',
        clients: 'Клиенти',
        clientsHint: 'Всеки клиент получава сертификат, издаден от CA на тази услуга. Премахването на клиент го ОТЗОВАВА: CRL се прегенерира веднага.',
        peerName: 'Име',
        publicKey: 'Публичен ключ',
        publicKeyMinted: 'Генерира го TVirt',
        peerAddress: 'Адрес в тунела',
        peerAddressHint: 'Празно = присвоен',
        allowedIps: 'Отдалечени подмрежи',
        allowedIpsHint: 'Разделени със запетая, маршрутизирани през този пиър',
        endpoint: 'Крайна точка',
        presharedKey: 'Предварително споделен ключ',
        keepalive: 'Keepalive (s)',
        addPeer: 'Добави пиър',
        addClient: 'Добави клиент',
        auth: 'Автентикация',
        authTls: 'Сертификати (TLS)',
        remote: 'Отдалечена крайна точка',
        remoteHint: 'хост:порт на отсрещния край — празно означава, че тази страна чака',
        peerRoutes: 'Отдалечени подмрежи',
        serverPublicKey: 'Публичен ключ на този сървър',
        ca: 'Сертификационен орган',
        listening: 'Слуша на',
        tunnel: 'Тунел',
        peerCount: '{n} пиъра',
        download: 'Изтегли профила',
        downloadError: 'Профилът не можа да бъде експортиран',
        lastHandshake: 'Последен хендшейк',
        never: 'никога',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Свързан',
        idle: 'Неактивен'
      },
      gateway: {
        attach: 'Тип на мрежата за слушане',
        attachOverlay: 'Оверлейна мрежа',
        attachNetwork: 'Логическа мрежа на фабриката',
        attachInterface: 'Суров интерфейс',
        overlay: 'Оверлейна мрежа',
        network: 'Логическа мрежа',
        interface: 'Име на интерфейса',
        interfaceHint: 'Хост интерфейс, който TVirt не управлява — адресът се приема на доверие',
        address: 'Адрес на слушане (шлюз)',
        addressHint: 'Шлюзовият адрес, към който сочат клиентите — вътре в подмрежата на мрежата за слушане',
        dnatTitle: 'DNAT правила',
        dnatHint: 'NAT по местоназначение: трафикът в съвпадението се пренасочва към нов адрес (и по избор нов порт). Всеки протокол от списъка — портовете там, където протоколът ги носи.',
        snatTitle: 'SNAT правила',
        snatHint: 'NAT по източник: трафикът в съвпадението излиза с пренаписан източник — нов явен адрес (и по избор нов порт), или masquerade върху изходния адрес, ако е оставено празно.',
        oneToOneTitle: '1:1 NAT правила',
        oneToOneHint: 'Всеки пакет за външния адрес се съпоставя на вътрешния, а вътрешният хост излиза като външния — всички протоколи, и двете посоки.',
        external: 'Външен адрес',
        internal: 'Вътрешен адрес',
        addOneToOne: 'Добави правило 1:1',
        family: 'Семейство',
        protocol: 'Протокол',
        source: 'Източник (адрес/подмрежа)',
        destination: 'Местоназначение (адрес/подмрежа)',
        invert: 'NOT',
        srcPorts: 'Портове източник',
        dstPorts: 'Портове местоназн.',
        dstPortsHint: 'Порт или диапазон (80, 8000-8099)',
        toAddress: 'Нов адрес',
        toPort: 'Нов порт',
        snatTo: 'Нов източник (празно = masquerade)',
        snatToHint: 'Явен адрес на източника; празно = masquerade върху изходния адрес',
        addDnat: 'Добави DNAT правило',
        addSnat: 'Добави SNAT правило',
        routesTitle: 'Статични маршрути',
        routesHint: 'Възелът маршрутизира между мрежите, към които е закачен (IP forwarding е включен); тези маршрути добавят достижимост отвъд тях — чисто ядро, динамичното маршрутизиране идва в следващ рунд.',
        routeDestination: 'Подмрежа местоназначение',
        routeGateway: 'Next hop',
        routeMetric: 'Метрика',
        addRoute: 'Добави маршрут',
        listening: 'Слуша на',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} маршрута'
      },
      unknownSince: 'Неизвестно — последен доклад преди {m} мин',
      lastWord: 'Последна дума',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Последен доклад',
      lastErrorRow: 'Последна грешка',
      recordsCount: '{n} ръчни записа',
      phase: {
        configured: 'Конфигурирана',
        running: 'В изпълнение',
        error: 'Грешка'
      },
      authorityNode: 'Отговорен възел (назначаване)',
      preferredNode: 'Предпочитан възел',
      preferredNodeHint: 'Меко предпочитание, никога ограничение: при следващото решение за разполагане инстанцията каца тук, ако този член е пригоден — само по себе си то не мести нищо; ходът е „Прехвърли отговорността“.',
      noPreference: 'Без предпочитание (автоматично разполагане)',
      moving: 'В движение',
      movingTooltip: 'Наблюдавана тук, докато отговорният възел назначава {node}: преместването тъкмо се изравнява.',
      placement: {
        title: 'Разполагане',
        loading: 'Преброяване в ход…',
        loadError: 'Преброяването на разполагането не отговори — опитайте по-късно.',
        draftHint: 'Преброяването се изчислява от декларираното мрежово свързване: ще се появи, щом услугата бъде създадена. Създаването се отказва, когато никой член не може да я обслужва, а отказът назовава механизма, изпразнил множеството.',
        eligibleCount: '{n} от {m} членове могат да обслужват тази инстанция',
        recommended: 'Препоръчан',
        eligible: 'Пригоден',
        notEligible: 'Непригоден',
        blockedReachability: 'мрежата не стига до този член',
        blockedRequireTag: 'блокиран от задължителен таг (requireNodes)',
        blockedExcluded: 'изключен от симулацията',
        preferenceUnknown: 'не е (вече) член на клъстера',
        preferenceIgnored: 'Предпочитанието „{node}“ днес не е пригодно: {reason}. Надделява препоръката на преброяването — никога грешка, услугата живее другаде.',
        emptyReachability: 'Никой член не може да обслужва тази инстанция: мрежата не стига доникъде — никаква корекция на таговете няма да помогне. Окабелете възела или преместете услугата там, където мрежата я има.',
        emptyRequireTag: 'Никой член не може да обслужва тази инстанция: задължителните тагове изпразниха множеството — премахнете записа от requireNodes или сложете таг на някой член.',
        spof: 'Единична точка на отказ',
        spofDetail: 'Точно един член може да приюти инстанцията: при отказ аварийното превключване няма къде да отиде. Услуга с няколко слушателя се мести като ЦЯЛО — кандидатът трябва да вижда ВСИЧКИ нейни мрежи: това е цената.',
        whatIf: 'Симулирай отсъстващи членове',
        whatIfHint: 'Въпросът „ами ако“ на изпразването: питайте ПРЕДИ евакуацията, не го откривайте при аварийното превключване.',
        survives: 'И без {nodes} услугата все още има дом.',
        notSurvives: 'Евакуирането на {nodes} оставя тази услуга СПРЯНА: производното ограничение надделява над достъпността (R30) — демон, жив там, където мрежата не стига, не служи никому и не тревожи никого.',
        transfer: 'Прехвърли отговорността',
        transferError: 'Прехвърлянето не успя',
        transferTarget: 'Целеви член',
        transferHint: 'Предлагат се само пригодните членове — предпочитание вътре във валидното множество, никога налагане. Няма задача: следващият проход на worker-ите Е преместването (старият възел жъне, новият изгражда).'
      }
    },
    fabric: {
      tabDerivation: 'Деривация',
      importNetwork: 'Импортирай от друг fabric',
      importTitle: 'Импортиране на логическа мрежа',
      importHint: 'Импортът е изричното присъединяване: мрежата остава на собственика (същата идентичност, същият stem, същият bridge tvf-<stem>) и оттук се мапва върху портовете/LAGG на този fabric — мапването Е твърдение, че доставката излиза в същия L2 домейн като на собственика.',
      importPick: 'Мрежа на собственика',
      importNone: 'Няма какво да се импортира: другите fabric нямат собствена мрежа, която този fabric вече да не познава',
      importedNetworksTitle: 'Импортирани мрежи',
      noImported: 'Няма импортирана мрежа',
      importedFrom: 'импортирана от {fabric}',
      importedBy: 'Импортирана от: {list}',
      importedCount: '+{n} импортирани',
      owner: 'Собственик',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Премахни импорта',
      unimportConfirm: 'Да се премахне ли импортът на мрежата {name} (собственик {fabric}) от този fabric? Отказва се, докато порт или LAGG на този fabric я мапва, или гост, App или услуга се обслужва само през този крак.',
      unimportRefused: 'Импортът още се използва — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Този възел вече взема тази мрежа от друг fabric, на който е член: възелът взема споделена мрежа само от ЕДИН от своите крака (два uplink-а на един L2 в bridge без STP са loop). Размапни я на портовете или LAGG на един от двата fabric.',
          otherFabricDerived: 'Документът носи блока на fabric, към който възелът вече не декларира кабел: първо приложи плана на този fabric (той предлага премахването на устройствата му) или поеми собствеността им с take-ownership, ако fabric-ът вече не съществува.'
        },
        hint: 'Планът за деривация O.3: за всеки окабелен възел състоянието, diff производно-vs-текущо, ДЕКЛАРИРАНАТА топология на бондовете, dual-stack флиповете и структурираните откази/предупреждения. Само за четене до ЯВНИЯ apply — нищо никога не каца само на възел.',
        refresh: 'Презареди плана',
        empty: 'Никой възел не е окабелен към този fabric (и никой вече не носи неговия блок).',
        refusal: 'Отказ',
        warning: 'Предупреждение',
        generation: 'поколение на документа {n}',
        state: {
          manual: 'Ръчен',
          derived: 'Производен',
          diverged: 'Отклонен'
        },
        topologyTitle: 'Декларирана топология',
        members: 'членове',
        primary: 'първичен',
        held: 'държан на ЕДИН член',
        form: {
          perNetworkBond: 'Бонд на мрежа',
          singleBond: 'Единствен резервен бонд',
          laggBond: 'LACP бонд (LAGG)',
          singlePort: 'Единичен порт'
        },
        colAction: 'Действие',
        colKind: 'Вид',
        colDevice: 'Device',
        colDetail: 'Детайл',
        action: {
          add: 'добави',
          remove: 'премахни',
          replace: 'замени'
        },
        diffEmpty: 'Няма чакащ diff — приложеният документ съвпада с рендера.',
        diffBlocked: 'Няма diff: отказите по-горе блокират този възел.',
        phasePlanned: 'планирано (стъпка 1 от 3)',
        phaseDraining: 'източва се (стъпка 2 от 3)',
        probeUnobserved: 'Сонда за източване: никога не е докладвана — празнотата е НЕИЗВЕСТНА (retire сега би бил отказан).',
        probeFailed: 'Сонда за източване: наблюдението СЕ ПРОВАЛИ — известните времеви печати се пренасят, никога «празно», което никой не е измерил.',
        probeActive: {
          one: 'Сонда: {n} установена връзка все още на стария адрес',
          other: 'Сонда: {n} установени връзки все още на стария адрес'
        },
        probeLastActive: 'последна активност {time}',
        probeEmpty: {
          one: 'Сонда: празно от {n} минута',
          other: 'Сонда: празно от {n} минути'
        },
        probeEmptyUnknown: 'Сонда: празно (откога — неизвестно).',
        impact: '{nics} vNIC и {apps} App на този възел използват тези мрежи: {list}',
        apply: 'Приложи на този възел',
        applyTitle: 'Приложи деривацията — {node}',
        applyIntro: 'Производната конфигурация пренаписва мрежовия документ на {node} ({n} промени) през същата врата като редактора host-network — включително checkpoint на NetworkManager и честна сонда. Предупрежденията на плана по-долу пътуват с акта: прочетете ги преди да потвърдите.',
        applyError: 'Apply се провали',
        applyRefused: 'Възелът отказа:',
        planMoved: 'Fabric се промени след този преглед — НИЩО не беше приложено. Планът е презареден: погледнете отново и опитайте пак.',
        retire: 'Изведи',
        retireTitle: 'Точка без връщане — извеждане на {address}',
        restore: 'Възстанови',
        restoreTip: 'Обратно към снимката отпреди apply (поколение {previous}) — отмяна на една стъпка (H13)',
        restoreTitle: 'Възстановяване на предишния документ — {node}',
        restoreIntro: 'Мрежовият документ на {node} се връща към снимката, направена преди последния apply (поколение {previous}), презаписана като поколение {next} на мястото на {current}. Worker-ът го привежда като всеки друг документ.',
        restoreRedo: 'Заместеният документ става новата снимка: повторното възстановяване е redo.',
        restoreClosesChain: 'Снимката е ръчният документ отпреди деривацията: веригата се затваря тук — няма повече отмяна, възелът е ръчен до следващия apply.',
        restoreConfirm: 'Възстанови',
        restoreError: 'Възстановяването не успя',
        retireIntro: 'Това премахва {address} ({network}) от {point} окончателно. След този акт пътят назад е ОБРАТНИЯТ флип — повторно деклариране на стария адрес през същия двигател — никога сляпо възстановяване.',
        retireOld: 'Стар адрес (премахнат)',
        retireNew: 'Нов адрес (остава)',
        retireEmptyFact: 'Сондата за източване докладва адреса празен: това премахване не прекъсва нито една наблюдавана връзка.',
        retireConfirm: 'Изведи адреса',
        severActiveLoss: {
          one: 'Прекъсни {n} установена връзка все още на стария адрес — тя умира с този акт',
          other: 'Прекъсни {n} установени връзки все още на стария адрес — те умират с този акт'
        },
        severUnknownLoss: 'Приеми НЕИЗВЕСТНОТО: сондата никога не е наблюдавала този адрес (или наблюдението се проваля) — живи връзки може да бъдат прекъснати.'
      },
      title: 'Фабрика',
      createTitle: 'Създай фабрика',
      networks: 'Мрежи',
      switches: 'Комутатори',
      ports: 'Портове',
      laggs: 'LAGG',
      subnets: 'Подмрежи',
      tabOverview: 'Преглед',
      tabNetworks: 'Логически мрежи',
      tabSwitches: 'Комутатори',
      overviewHint: 'Фабриката с един поглед: всяка логическа мрежа с MTU и подмрежа (VLAN живеят само в съпоставките по порт/по LAGG — една и съща мрежа може да пътува с различни тагове на различни портове). Фабриката е регистърът на ВЪНШНА инфраструктура — TVirt наблюдава и декларира, никога не провизира, и пипа само NIC, регистрирани под негов контрол.',
      absorptionHint: 'Всяка декларирана тук подмрежа ИЗВЕЖДА записа си в IPAM регистъра в същия запис — живее и умира с мрежата.',
      scopeFixedHint: 'Скоупът е фиксиран в корена на клъстера: физическата инфраструктура по дефиниция обхваща целия клъстер.',
      networksHint: 'Всяка мрежа носи задължително MTU (по подразбиране 1500) и задължителна подмрежа; шлюзът, DNS сървърите и статичните маршрути, декларирани тук, са ЕДИНСТВЕНИЯТ ИЗТОЧНИК за NIC на сървърите, приложенията и мрежовите услуги.',
      switchesHint: 'Ръчният регистър: един порт е неизползван, съпоставен (untagged трафик и по VLAN таг върху логическите мрежи) или член на LAGG — членът не носи собствени съпоставки.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Задължителна — IPAM извежда автоматично записа ѝ в регистъра',
      nodeAddressing: 'Адресиране на възлите',
      nodeAddressingNone: 'Няма — без адрес за възел',
      nodeAddressingPool: 'Пул — по един устойчив адрес за всеки обслужен възел',
      nodeAddressingHint: 'С Пул деривацията на фабриката назначава на всеки обслужен възел адрес от диапазоните, запазени за TVirt (устойчив след назначаване).',
      backing: 'Backing',
      gateway: 'Шлюз',
      ranges: 'Запазени диапазони',
      dns: 'DNS сървъри (разделени със запетая)',
      dnsShort: 'DNS',
      singleSourceHint: 'Шлюзът, DNS и маршрутите, декларирани тук, са единственият източник — NIC на сървърите, приложенията и мрежовите услуги черпят оттук',
      routesTitle: 'Статични маршрути',
      routeDestination: 'Местоназначение (CIDR)',
      routeVia: 'През (next hop)',
      portUsed: 'Използван',
      vlanMappings: 'VLAN съпоставки',
      vlanTag: 'VLAN таг',
      vlanNetwork: 'Логическа мрежа',
      nameTaken: 'Името вече е използвано във фабриката',
      addNetwork: 'Добави мрежа',
      editNetwork: 'Редактирай мрежата',
      deleteNetwork: 'Премахни мрежата',
      deleteNetworkConfirm: 'Да се премахне ли логическата мрежа {name} от фабриката? Изведената ѝ подмрежа в IPAM умира с нея (отказва се, докато услуга или приложение я използва). Мапингите по портове и LAGG, които я сочат, се изчистват.',
      switchName: 'Комутатор',
      portName: 'Порт',
      positionHint: 'Физическа позиция (по избор) — същият речник като разположението на сървърите; само декларативна',
      addSwitch: 'Добави комутатор',
      editSwitch: 'Редактирай комутатора',
      deleteSwitch: 'Премахни комутатора',
      deleteSwitchConfirm: 'Да се премахне ли комутаторът {name} с всичките му портове? LAGG се свиват съответно (и умират под двата порта).',
      addPort: 'Добави порт',
      editPort: 'Редактирай порта',
      deletePort: 'Премахни порта',
      deletePortConfirm: 'Да се премахне ли портът {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (таг:мрежа)',
      taggedShort: 'Tagged',
      portCabling: 'Окабеляване',
      portState: 'Състояние',
      stateUnused: 'неизползван',
      stateMapped: 'съпоставен',
      laggPortGuard: 'Порт, член на LAGG, се променя от страната на LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'Един LAGG е 2+ порта в LACP и може да пресича комутаторите (MLAG, прозрачно); влизат само неизползвани портове, LAGG е повърхността за съпоставяне, премахнат порт става отново неизползван.',
      addLagg: 'Добави LAGG',
      editLagg: 'Редактирай LAGG',
      deleteLagg: 'Премахни LAGG',
      deleteLaggConfirm: 'Да се премахне ли LAGG {name}? Портовете му членове стават отново неизползвани.',
      lacpRate: 'LACP rate',
      laggPorts: 'Портове членове (2+)',
      laggPortsHint: 'Влизат само неизползвани портове — първо освободете съпоставения порт',
      noNetworks: 'Няма декларирани логически мрежи.',
      noSwitches: 'Няма декларирани комутатори.',
      noLaggs: 'Няма декларирани LAGG.',
      staleConflict: 'Друг оператор промени тази фабрика, докато я редактираше: записът беше отхвърлен, за да не се изтрие работата му. Твоите промени са още тук, непокътнати. Обновената фабрика вече е презаредена: потвърди отново, за да ги приложиш върху нея, или откажи и виж какво се е променило.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Само изведен: всяка подмрежа се ражда от логическа мрежа на фабриката или от оверлей — променя се при източника. Присвоените адреси показват КОЙ ги държи; запазените за TVirt диапазони са пуловете на автоматичното присвояване.',
      search: 'Търсене по име, CIDR или адрес',
      empty: 'Няма мрежи — декларирайте логическа мрежа на фабриката или оверлейна подмрежа: IPAM се извежда от тях автоматично.',
      reserved: 'Диапазони, запазени за TVirt',
      address: 'Адрес',
      origin: 'Произход',
      origin_declared: 'деклариран',
      origin_observed: 'наблюдаван',
      holder: 'Държан от',
      noAddresses: 'Няма известни адреси в тази подмрежа.',
      sourceFabric: 'Фабрика',
      sourceOverlay: 'Оверлей',
      editAtSource: 'Промени при източника'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Групи на защитната стена',
      createTitle: 'Нова група на защитната стена',
      editTitle: 'Промяна на група на защитната стена',
      empty: 'Няма групи на защитната стена — създайте една: преизползваем речник от правила, към който NIC на гостите сочат по име.',
      nameHint: 'Букви, цифри и вътрешни . - _; уникално в рамките на своя скоуп (едноименните другаде се различават чрез /scope/име)',
      description: 'Описание',
      descriptionHint: 'Един ред намерение, показван навсякъде, където групата се избира',
      enforced: 'Наложена върху скоупа',
      enforcedHint: 'Изключено: чист речник — правилата обвързват само NIC, които сочат групата. Включено: правилата обвързват всеки NIC на гост с включена защитна стена под скоупа на групата, сочен или не.',
      enforcedChip: 'Наложена',
      enforcedChipHint: 'Правилата обвързват всеки NIC на гост с включена защитна стена под скоупа на групата, сочен или не',
      enforceWarning: 'Включвайки налагането, правилата обвързват ВСЕКИ NIC на гост с включена защитна стена под {scope} при следващото изравняване, дори без изрично сочене — а вътре в активна chain drop на предшественик е окончателен: нивата отдолу не го отварят отново.',
      unenforceInfo: 'Премахвайки налагането, правилата остават само върху NIC, които сочат групата изрично.',
      rules: 'Правила',
      tabOverview: 'Преглед',
      tabRules: 'Правила',
      orderHint: 'Редът на редовете Е редът на оценяване вътре в групата: печели първото съвпаднало правило.',
      statefulHint: 'Stateful е подразбиращ се: отговорите на допуснатия трафик минават сами (established/related се приемат, invalid се отхвърля — инжектира ги двигателят, не се пишат на ръка).',
      noRules: 'Няма правила — речник в строеж: да го сочиш е позволено и не поражда нищо.',
      addRule: 'Добави правило',
      direction: 'Посока',
      directionIn: 'Входяща',
      directionOut: 'Изходяща',
      action: 'Действие',
      action_accept: 'Приеми',
      action_drop: 'Изхвърли',
      action_reject: 'Отхвърли',
      protocol: 'Протокол',
      protocolAny: 'Всеки',
      ports: 'Портове',
      source: 'Източник',
      dest: 'Дестинация',
      comment: 'Коментар',
      addressHint: 'IPv4 CIDR или <фабрика>/<логическа мрежа>; празно = всеки',
      moveUp: 'Премести нагоре',
      moveDown: 'Премести надолу',
      nicFirewall: 'Защитна стена',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Групи на защитната стена',
      nicGroupsPlaceholder: 'Изберете група…',
      nicGroupsHint: 'Видимите групи, включително тези от по-горните скоупове (използваеми надолу, като таговете)',
      nicGroupCount: { one: '{n} група на защитната стена', other: '{n} групи на защитната стена' },
      nicOff: 'Защитната стена е изключена',
      pendingRestartHint: 'Промените по защитната стена следват модела записано/приложено: изчакват следващия цикъл на захранване (PendingRestart). Групите, наложени от по-горните скоупове, се прилагат, когато защитната стена на NIC е включена.',
      appConvergeHint: 'Промените по защитната стена се прилагат при следващото изравняване на контейнера. Групите, наложени от по-горните скоупове, се прилагат, когато защитната стена е включена.',
      enforcedAncestors: 'Наложени от по-горните скоупове',
      enforcedAncestorsHint: 'Тази група се прилага към всеки NIC под своя скоуп с ВКЛЮЧЕНА защитна стена — превключвателят е главният ключ на NIC (изключен = никаква chain, предшествениците включително); вътре в активна chain авторитетът на предшественика е окончателен: неговият drop не се отваря отново отдолу.'
    }
  }
}
